var _mask, _rect, _mask2, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaturityDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_46002_4911",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 27.0012,
    width: 7,
    height: 13,
    rx: 1.83333
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 27.0012,
    width: 7,
    height: 13,
    rx: 1.83333,
    stroke: "#2E2E2E",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_46002_4911)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_46002_4911",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 21.0012,
    width: 7,
    height: 19,
    rx: 1.83333
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 21.0012,
    width: 7,
    height: 19,
    rx: 1.83333,
    stroke: "#2E2E2E",
    strokeWidth: 4,
    mask: "url(#path-2-inside-2_46002_4911)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 20.8346C24.25 20.3743 24.6231 20.0012 25.0833 20.0012H28.4167C28.8769 20.0012 29.25 20.3743 29.25 20.8346V38.1679C29.25 38.6281 28.8769 39.0012 28.4167 39.0012H25.0833C24.6231 39.0012 24.25 38.6281 24.25 38.1679V20.8346Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 8.83452C33.75 8.37429 34.1231 8.00119 34.5833 8.00119H37.9167C38.3769 8.00119 38.75 8.37429 38.75 8.83452V38.1679C38.75 38.6281 38.3769 39.0012 37.9167 39.0012H34.5833C34.1231 39.0012 33.75 38.6281 33.75 38.1679V8.83452Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.67 4.47528C28.5956 4.0517 28.192 3.76857 27.7684 3.8429L20.8658 5.05411C20.4422 5.12844 20.1591 5.53207 20.2334 5.95566C20.3077 6.37924 20.7114 6.66236 21.1349 6.58804L27.2706 5.5114L28.3473 11.6471C28.4216 12.0707 28.8252 12.3538 29.2488 12.2795C29.6724 12.2052 29.9555 11.8015 29.8812 11.3779L28.67 4.47528Z",
    fill: "#C63031"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3258 4.86749C25.1314 9.11011 17.2313 18.122 4.94238 20.2287",
    stroke: "#C63031",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaturityDevelopment);
export default __webpack_public_path__ + "static/media/Maturity & Development.d1548f307c79a10675c5679515b59652.svg";
export { ForwardRef as ReactComponent };